import { containsIgnoreCase } from '@dte/otw-utils-core/src/strings/equalsIgnoreCase';

import {
	type PremiseLocation,
	LocationType,
	type LocationV2,
	type NonPremiseLocation,
} from '../../../interfaces/api/Location';

export function isNonPremiseLocationType(locationType: LocationType | undefined): locationType is LocationType {
	return containsIgnoreCase([LocationType.CrossStreet, LocationType.GLN], locationType);
}

export function isGLNLocationType(type: LocationType | undefined): boolean {
	return type === LocationType.GLN;
}

export function isNonPremiseLocation(location: LocationV2 | undefined): location is NonPremiseLocation {
	if (!location) {
		return false;
	}
	return isNonPremiseLocationType(location.type);
}

/**
 * Assume a premise report as long as the type isn't a non-premise location type
 *
 * @param location
 * @returns
 */
export function isPremiseLocation(location: LocationV2 | undefined): location is PremiseLocation {
	// Make sure we have a premise id
	if (!location?.premiseId) {
		return false;
	}

	// Make sure it's not a non-premise location type
	if (isNonPremiseLocationType(location.type)) {
		return false;
	}

	return true;
}
